import { xml2json, js2xml } from "xml-js";
import { createHash } from "crypto";
import { API } from "aws-amplify";

const convertBase64ToArray = (base64: string) => {
  const rawString = atob(base64);
  const int8Array = new Int8Array(rawString.length);
  for (let i = 0; i < rawString.length; i++) {
    int8Array[i] = rawString.charCodeAt(i);
  }
  const int16Array = new Int16Array(int8Array.buffer);
  return Array.from(int16Array);
};

const convertToAnonymous = (XMLObject: any): Array<any> => {
  for (const element of XMLObject.RestingECG.Waveform) {
    if (element.WaveformType._text == "Median") {
      const ecgDataPerLead: Array<any> = [];
      element.LeadData.forEach((lead: any) => {
        ecgDataPerLead.push({
          lead: lead.LeadID._text,
          data: convertBase64ToArray(lead.WaveFormData._text),
          length: parseInt(lead.LeadSampleCountTotal._text),
          sample_rate: parseInt(element.SampleBase._text),
          baseline: parseInt(lead.LeadOffsetFirstSample._text),
          gain: parseFloat(lead.LeadAmplitudeUnitsPerBit._text),
          unit: lead.LeadAmplitudeUnits._text.toLowerCase(),
        });
      });
      return ecgDataPerLead;
    }
  }
  return [];
};

const encodeECG = async (ecg_data: Array<any>): Promise<number[]> => {
  const apiName = "encodeECG";
  const path = "/encode";

  const myInit = {
    body: ecg_data,
  };

  const encoding = await API.post(apiName, path, myInit)
    .then((response: any) => {
      return response.encoding;
    })
    .catch((error: any) => {
      console.log(error.response);
      return [];
    });

  return new Promise((resolve) => {
    resolve(encoding);
  });
};

export const ProcessUpload = async (result: ArrayBuffer, setProgress: (message: any) => void, fileName: string): Promise<any> => {
  // try {
  const content = new TextDecoder().decode(result);
  const XMLObject = JSON.parse(xml2json(content, { compact: true, spaces: 4 }));
  if ("RestingECG" in XMLObject) {
    const ecgData = convertToAnonymous(XMLObject);
    const encoding = await encodeECG(ecgData);
    let ID: string;
    if ("PatientDemographics" in XMLObject.RestingECG) {
      if ("PatientID" in XMLObject.RestingECG.PatientDemographics) {
        ID = XMLObject.RestingECG.PatientDemographics.PatientID._text;
      } else {
        ID = fileName;
      }
    } else {
      ID = fileName;
    }
    const encodingObject = {
      ID: ID,
      Date: XMLObject.RestingECG.TestDemographics.AcquisitionDate._text,
      Time: XMLObject.RestingECG.TestDemographics.AcquisitionTime._text,
      Encoding: encoding,
    };
    return encodingObject;
  } else {
    return {};
  }
  // } catch {
  //   setProgress("Invalid file uploaded");
  //   throw "Invalid file error";
  // }
};

// for future pseudonymizer
//  delete result1.RestingECG.PatientDemographics;
//  delete result1.RestingECG.Order;
//  delete result1.RestingECG.TestDemographics.OverreaderID;
//  delete result1.RestingECG.TestDemographics.EditorID;
//  delete result1.RestingECG.TestDemographics.OverreaderLastName;
//  delete result1.RestingECG.TestDemographics.OverreaderFirstName;
//  delete result1.RestingECG.TestDemographics.EditorLastName;
//  delete result1.RestingECG.TestDemographics.EditorFirstName;
//  delete result1.RestingECG.TestDemographics.SecondaryID;
//  const result2 = js2xml(result1, { compact: true, spaces: 4 });

// Create pseudo and testID
// const patientID = result1.RestingECG.PatientDemographics.PatientID._text;
// const pseudoID = createPseudoID(result1.RestingECG.PatientDemographics.PatientID._text);
// const testID = createTestID(
//   result1.RestingECG.PatientDemographics.PatientID._text,
//   result1.RestingECG.TestDemographics.AcquisitionDate._text,
//   result1.RestingECG.TestDemographics.AcquisitionTime._text
// );
// console.log(pseudoID, testID);

// const createPseudoID = (PatientID: string): string => {
//   return createHash("sha256").update(PatientID).digest("hex").substr(0, 16);
// };

// const createTestID = (PatientID: string, AcquisitionDate: string, AcquisitionTime: string): string => {
//   const combinedString = PatientID.concat(AcquisitionDate, AcquisitionTime);
//   return createHash("sha256").update(combinedString).digest("hex").substr(0, 16);
// };
